const CurrencyFormatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});
const NumberFormatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});
const IntegerFormatter = new Intl.NumberFormat("en-US", {});
const DateTimeFormatter = new Intl.DateTimeFormat("en-US-u-hc-h23", {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
	hour: "numeric",
	minute: "numeric",
	second: "numeric",
	hour12: false,
	//  timeZone: 'America/Los_Angeles'
});
const DateFormatter = new Intl.DateTimeFormat("en-US", {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
	// timeZone: 'America/Los_Angeles'
});
const TimeFormatter = new Intl.DateTimeFormat("en-US-u-hc-h23", {
	hour: "2-digit",
	minute: "numeric",
	second: "numeric",
	hour12: false,
	// timeZone: 'America/Los_Angeles'
});
export {
	CurrencyFormatter,
	NumberFormatter,
	IntegerFormatter,
	DateTimeFormatter,
	DateFormatter,
	TimeFormatter,
};
